import { useState, useEffect } from "react";
import {
  Box,
  Button,
  CardMedia,
  Card,
  TextField,
  Autocomplete,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingFAQ } from "./UseLandingFAQ";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../../hooks/useBreakpoints";

export default function FAQInformation(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { validate, updateFAQBox, addFAQBox } = UseLandingFAQ();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: 0,
    aid: props.aid ? props.aid : "",
    headerColorName: undefined,
    title: undefined,
    title2: undefined,
    moreTitle: undefined,
    columnsDesktop: undefined,
    columnsMobile: undefined,
    moreURL: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: state.icon ? state.icon : "",
    file2: undefined,
    url2: state.icon2 ? state.icon2 : "",
  });
  const headerColors = ["بدون رنگ", "primary", "secondary"];

  useEffect(() => {
    if (props.model) {
      setState({
        id: props.model.id,
        aid: props.model.aid,
        headerColorName:
          props.model.headerColorName == null
            ? "بدون رنگ"
            : props.model.headerColorName,
        title: props.model.title ? props.model.title : "بدون عنوان",
        title2: props.model.title2 ? props.model.title2 : "",
        columnsDesktop: props.model.columnsDesktop
          ? props.model.columnsDesktop
          : "",
        columnsMobile: props.model.columnsMobile
          ? props.model.columnsMobile
          : "",
        moreTitle: props.model.moreTitle,
        moreURL: props.model.moreURL,
      });
      setImgState({
        file: undefined,
        url: props.model.icon ? props.model.icon : "",
        file2: undefined,
        url2: props.model.icon2 ? props.model.icon2 : "",
      });
    }
  }, [props.model]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };
  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      file2: file[0],
      url2: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Box
      sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={state.title ? state.title : ""}
          error={errorState.title}
          label="عنوان اول"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={state.title2 ? state.title2 : ""}
          label="عنوان دوم"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title2: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={state.moreTitle ? state.moreTitle : ""}
          label="عنوان لینک"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreTitle: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.moreURL ? state.moreURL : ""}
          label="آدرس لینک"
          size="small"
          sx={{
            textarea: {
              direction: "rtl",
            },
          }}
          multiline
          rows={2}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreURL: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <Autocomplete
          size="small"
          value={state.headerColorName ? state.headerColorName : ""}
          onChange={(event, newValue) => {
            if (newValue == "بدون رنگ") {
              setState({
                ...state,
                headerColorName: null,
              });
            } else if (newValue) {
              setState({
                ...state,
                headerColorName: newValue,
              });
            } else {
              setState({
                ...state,
                headerColorName: null,
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          sx={{ width: "80%" }}
          getOptionLabel={(option) => option}
          fullWidth
          options={headerColors}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="رنگ هدر" />
          )}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          fullWidth
          value={state.columnsMobile ? state.columnsMobile : ""}
          label="تعداد ستون موبایل"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, columnsMobile: evt.target.value });
          }}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <TextField
          fullWidth
          value={state.columnsDesktop ? state.columnsDesktop : ""}
          label="تعداد ستون دسکتاپ"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, columnsDesktop: evt.target.value });
          }}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box
        gridColumn={isSmall ? "span 12" : "span 3"}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 5,
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "150px", height: "auto" }}>
              <Card
                sx={{
                  // bgcolor: imgState.url && "black",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url ? imgState.url : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage2(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "150px", height: "auto" }}>
              <Card
                sx={{
                  // bgcolor: imgState.url2 && "black",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url2 ? imgState.url2 : "/static/img/nobanner.jpg"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}

      <Box
        gridColumn={isSmall ? "span 12" : "span 6"}
        sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          sx={{ width: "100px" }}
          variant="contained"
          onClick={() => {
            if (validate(state, setErrorState) == 200) {
              setProgress(true);
              if (state.id == 0) {
                addFAQBox(state, imgState.file, imgState.file2, (calback) => {
                  navigate("/landingmanagment/landingComponents/faq", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              } else {
                updateFAQBox(
                  state,
                  imgState.file,
                  imgState.file2,
                  (calback) => {
                    props.callback();
                  },
                );
              }
            }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
